import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordFormComponent } from './change-password-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { StatusPopupModule } from '../../../_shared/modules/status-popup/status-popup.module';
import { ChangePasswordFormRoutingModule } from './change-password-form-routing.module';



@NgModule({
    declarations: [
        ChangePasswordFormComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        StatusPopupModule,
        ChangePasswordFormRoutingModule
    ],
    providers: [
        {
            provide: MatDialogRef,
            useValue: {}
        }
    ],
    exports: [
        ChangePasswordFormComponent
    ]
})
export class ChangePasswordFormModule { }
